/**
 * Devuelve un string con los valores del objeto pasado en entrada
 *
 * @param {object} value - el objeto {loquesea: value}
 * @return {string}
 */

export function string(value = '') {
  if (value === null) {
    return '';
  }

  if (typeof value === 'boolean' || typeof value === 'number') {
    return `${value}`;
  }

  if (typeof value === 'object') {
    if (Array.isArray(value)) {
      return value.map(val => string(val)).join(' ');
    }
    return Object.values(value)
      .map(val => string(val))
      .join(' ');
  }
  return value;
}
